'use client';

import { c as _c } from "react/compiler-runtime";
import { Input } from '@heroui/react';
import { LucideSearch } from 'lucide-react';
import Link from 'next/link';
import InView from '@/components/ui/in-view';
import { APP_ROUTES } from '@/shared/constants/app-routes';
import { buildAppRoute } from '@/shared/functions/build-app-route';
import { FAQS_LIST_SECTION_ID } from '../../shared/constants/section-ids';
import { useFaqsSearchParams } from '../../shared/functions/use-faqs-search-params';
import FaqsList from './components/faqs-list';
export default function FaqsIntro() {
  const $ = _c(24);
  const {
    search,
    setSearch
  } = useFaqsSearchParams();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0,
      filter: "blur(4px)"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      hidden: t0,
      visible: {
        opacity: 1,
        filter: "blur(0px)",
        transition: {
          delay: 0.1
        }
      }
    };
    t2 = {
      margin: "0px 0px -100px 0px",
      once: true
    };
    t3 = {
      duration: 0.3,
      ease: "easeInOut"
    };
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <InView variants={t1} viewOptions={t2} transition={t3} className="w-full"><h1 className="text-center text-4xl font-normal leading-relaxed text-paragraph sm:text-5xl">Perguntas frequentes</h1></InView>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      opacity: 0,
      filter: "blur(4px)"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      hidden: t5,
      visible: {
        opacity: 1,
        filter: "blur(0px)",
        transition: {
          delay: 0.2
        }
      }
    };
    t7 = {
      margin: "0px 0px -100px 0px",
      once: true
    };
    t8 = {
      duration: 0.3,
      ease: "easeInOut"
    };
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="sm:text-base text-sm text-default-500">Digite uma palavra-chave ou pergunta para encontrar ajuda rapidamente. Não encontrou o que procurava?{" "}<Link href={buildAppRoute(APP_ROUTES.EXTERNAL.SUPPORT)} className="underline">Fale conosco</Link></p>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== setSearch) {
    t10 = e => setSearch(e.target.value);
    $[10] = setSearch;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      inputWrapper: ""
    };
    t12 = <LucideSearch size={22} />;
    $[12] = t11;
    $[13] = t12;
  } else {
    t11 = $[12];
    t12 = $[13];
  }
  let t13;
  if ($[14] !== search || $[15] !== t10) {
    t13 = <aside className="flex w-full flex-col max-w-7xl mx-auto justify-center items-center gap-6">{t4}<InView variants={t6} viewOptions={t7} transition={t8} className="w-full"><Input name="search" description={t9} placeholder="" variant="bordered" size="lg" value={search} onChange={t10} classNames={t11} startContent={t12} /></InView></aside>;
    $[14] = search;
    $[15] = t10;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      opacity: 0,
      filter: "blur(4px)"
    };
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  let t16;
  let t17;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      hidden: t14,
      visible: {
        opacity: 1,
        filter: "blur(0px)",
        transition: {
          delay: 0.2
        }
      }
    };
    t16 = {
      margin: "0px 0px -100px 0px",
      once: true
    };
    t17 = {
      duration: 0.3,
      ease: "easeInOut"
    };
    $[18] = t15;
    $[19] = t16;
    $[20] = t17;
  } else {
    t15 = $[18];
    t16 = $[19];
    t17 = $[20];
  }
  let t18;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <InView variants={t15} viewOptions={t16} transition={t17} className="relative max-w-7xl mx-auto w-full overflow-hidden"><FaqsList /></InView>;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] !== t13) {
    t19 = <section id={FAQS_LIST_SECTION_ID} className=" scroll-mt-20 flex w-full mx-auto flex-col items-start gap-6 px-6 pt-14 sm:px-12 xl:px-20">{t13}{t18}</section>;
    $[22] = t13;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  return t19;
}